<div id="body-wrap" class="body-wrap" #dialogContainer>

    <video-background>Loads the background video</video-background>

    <!-- Updates the section with certain classes needed for components-->
    <section updateSection>
        <router-outlet></router-outlet>
    </section>

</div>

<footer class="footer">
    <legal-notice-buttons></legal-notice-buttons>
    <div class="logo-athand"></div>
</footer>

<audio-controls></audio-controls>
